import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_STUDENT,
  GET_STUDENTS,
  GET_STUDENTS_BY_FILTER,
  GET_STUDENTS_BY_CODE__OR_NAME,
  ADD_STUDENT,
  ADD_STUDENTS_UPLOAD,
  UPDATE_STUDENT,
  DELETE_STUDENT,
} from '@/queries/modules/profile/student.js';

export async function getStudents(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.student;
    } else {
      context.commit('setStudents', data.getStudents);
      context.commit('setSuccess', null);
      return data.getStudents
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

export async function getStudentsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setStudents', data.getStudentsByFilter);
      context.commit('setSuccess', null);

      return data.getStudentsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getStudentsByCodeOrName(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTS_BY_CODE__OR_NAME,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setStudents', data.getStudentsByCodeOrName);
      context.commit('setSuccess', null);

      return data.getStudentsByCodeOrName;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getStudent(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.student;
    } else {
      context.commit('setStudent', data.getStudent);
      context.commit('setSuccess', null);
      return data.getStudent
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

export async function addStudent(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_STUDENT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const students = [...context.state.students];
      students.push(data.addStudent);
      context.commit('setStudents', students);
      context.commit('setSuccess', newItemSuccess(data.addStudent.code));

      return data.addStudent
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addStudentsUpload(context, payload) {
  context.commit('setProcessing', true);
  try {

    const result = await apolloClient
      .mutate({
        mutation: ADD_STUDENTS_UPLOAD,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', updateItemSuccess(data.addStudentsUpload.length));

      return data.addStudentsUpload
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateStudent(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_STUDENT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.students.findIndex(item => item.id === data.updateStudent.id);
      const students = [
        ...context.state.students.slice(0, index),
        data.updateStudent,
        ...context.state.students.slice(index + 1)
      ];
      context.commit('setStudents', students);
      context.commit('setSuccess', updateItemSuccess(data.updateStudent.code));

      return data.updateStudent
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteStudent(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_STUDENT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.students.findIndex(item => item.id === data.deleteStudent.id);
      const students = [
        ...context.state.students.slice(0, index),
        ...context.state.students.slice(index + 1)
      ];
      context.commit('setStudents', students);
      context.commit('setSuccess', deleteItemSuccess(data.deleteStudent.code));

      return data.deleteStudent
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}
